import { useMemo, useState } from "react";
import useReveal from "./useReveal";
import { LEAD_SAMPLES } from "./data";

const uniqSorted = (arr) => Array.from(new Set(arr)).sort();

const Examples = () => {
    const [ref, visible] = useReveal();
    const [topic, setTopic] = useState("");
    const [region, setRegion] = useState("");

    const topics = useMemo(() => uniqSorted(LEAD_SAMPLES.map((l) => l.t)), []);
    const regions = useMemo(() => uniqSorted(LEAD_SAMPLES.map((l) => l.r)), []);

    const list = LEAD_SAMPLES.filter(
        (l) => (!topic || l.t === topic) && (!region || l.r === region)
    );

    return (
        <section
            className={`sect reveal${visible ? " is-in" : ""}`}
            id="examples"
            ref={ref}
        >
            <div className="wrap">
                <div className="sect__head">
                    <span className="eyebrow">Живые заявки</span>
                    <h2 className="sect__title">Примеры реальных лидов из нашей базы</h2>
                    <p className="sect__lead">
                        Настоящие обращения последних недель. Имена и телефоны скрыты —
                        покупатель получает их полностью.
                    </p>
                </div>
                <div className="filters">
                    <select
                        aria-label="Фильтр по тематике"
                        value={topic}
                        onChange={(e) => setTopic(e.target.value)}
                    >
                        <option value="">Все тематики</option>
                        {topics.map((t) => (
                            <option key={t} value={t}>
                                {t}
                            </option>
                        ))}
                    </select>
                    <select
                        aria-label="Фильтр по региону"
                        value={region}
                        onChange={(e) => setRegion(e.target.value)}
                    >
                        <option value="">Все регионы</option>
                        {regions.map((r) => (
                            <option key={r} value={r}>
                                {r}
                            </option>
                        ))}
                    </select>
                    <button
                        type="button"
                        className="linkbtn"
                        onClick={() => {
                            setTopic("");
                            setRegion("");
                        }}
                    >
                        Сбросить
                    </button>
                </div>
                <div className="leads">
                    {list.map((l, i) => (
                        <article className="lead" key={i}>
                            <div className="lead__top">
                                <span className="lead__topic">{l.t}</span>
                                <span className="lead__region">{l.r}</span>
                                <span className="lead__date">{l.d}</span>
                            </div>
                            <p className="lead__q">{l.q}</p>
                            <div className="lead__foot">
                                <span className="lead__masked">+7 (9••) •••-••-••</span>
                                <span className="lead__lock">
                                    Имя и телефон открываются покупателю
                                </span>
                            </div>
                        </article>
                    ))}
                </div>
                {list.length === 0 && (
                    <p className="leads__empty">
                        По этому сочетанию примеров нет — но заявки в такой связке у нас есть.
                        Зарегистрируйтесь и уточните объём в личном кабинете.
                    </p>
                )}
            </div>
        </section>
    );
};

export default Examples;
